import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['slots', 'checkbox']
  static values = { comparadorType: String }

  initialize () {
    if (Array.from(this.selected.keys()).filter((slot) => slot.includes(this.comparadorName)).length === 0) {
      this.clear()
    }
  }

  connect () {
    this.refresh()
    document.addEventListener('ajax:success', this.refresh.bind(this))
  }

  refresh () {
    const defaultItem = this.defaultItem

    let selectedValues = Array.from(this.selected.values())

    for (let i = 0; i < 4; i++) {
      let slogLogo = this.logos[i]
      const slotTitle = slogLogo.closest('div').querySelector('small')

      if (selectedValues[i]) {
        slogLogo.src = selectedValues[i].src
        slogLogo.alt = selectedValues[i].alt
        slogLogo.title = selectedValues[i].title

        slotTitle.textContent = selectedValues[i].alt
      } else {
        slogLogo.src = defaultItem.src
        slogLogo.alt = defaultItem.title
        slogLogo.title = defaultItem.title

        slotTitle.textContent = defaultItem.title
      }
    }

    this.checkboxTargets.forEach((checkbox) => {
      checkbox.disabled = this.selected.size === 4
      checkbox.checked = false

      if (selectedValues.map((e) => e.value).includes(checkbox.value)) {
        checkbox.disabled = false
        checkbox.checked = true
      }
    })
  }

  add (value) {
    const item = document.querySelector('#img_' + value)

    this.selected.set([this.comparadorName, value].join('_'), {
      src: item.src,
      alt: item.alt || 'Listo para comparar',
      title: item.title || 'Listo para comparar',
      value: value
    })

    this.refresh()
  }

  remove (value) {
    this.selected.delete([this.comparadorName, value].join('_'))
    this.refresh()
  }

  checkboxOnChange (event) {
    (event.target.checked) ? this.add(event.target.value) : this.remove(event.target.value)
  }

  clear () {
    this.selected.clear()
    this.refresh()
  }

  submit (event) {
    if (this.selected.size < 2) return
    var params = Array.from(this.selected.values()).map(a => a.value).reduce((a,b) => a + '/' + b)
    window.location.replace(this.slotsTarget.dataset.url + '/' + params)
  }

  get defaultItem () {
    let defaultItem = document.createElement('img')

    defaultItem.src = '//via.placeholder.com/150x40/d9d9d9/737373?text=Disponible'
    defaultItem.title = 'Selecciona uno'

    return defaultItem
  }

  get logos () {
    return this.slotsTarget.querySelectorAll('img')
  }

  get comparadorName () {
    return this.comparadorTypeValue || window.location.pathname.split('/').pop()
  }

  get selected () {
    const that = this

    // We return a proxy that will call the setter any time the map of selected products changes in any way.
    // Thus, the state of the comparador is always synced in memory, DOM and the cookie.
    return new Proxy(new Map(JSON.parse(this.slotsTarget.dataset.selected || '[]')), {
      get (target, trapName) {
        if (['size', 'target'].includes(trapName)) return target[trapName]

        return function (...args) {
          const trapResult = target[trapName](...args)
          that.selected = target
          return trapResult
        }
      }
    })
  }

  set selected (value) {
    Cookies.set('comparadores', JSON.stringify(Array.from(value)))
    this.slotsTarget.dataset.selected = JSON.stringify(Array.from(value))
  }
}
